// Portaled Select/MultiSelect/DatePicker dropdowns mount outside a surrounding filter
// Popover. Mantine's useClickOutside treats clicks there as "outside" and closes the
// popover. This bubble-phase listener runs after the dropdown item handles mousedown
// (selection) but uses stopImmediatePropagation to block the Popover's document
// listener on the same phase. Registered at module load so it runs before Popover
// listeners added when a popover opens.
const PORTALED_DROPDOWN_CLASSES = ['mantine-DatePicker-dropdown', 'mantine-MultiSelect-dropdown', 'mantine-Select-dropdown'];

const stopIfInsidePortaledDropdown = (e) => {
    const path = e.composedPath ? e.composedPath() : [];
    const insideDropdown = path.some((el) => PORTALED_DROPDOWN_CLASSES.some((className) => el?.classList?.contains?.(className)));

    if (insideDropdown) {
        e.stopImmediatePropagation();
    }
};

document.addEventListener('mousedown', stopIfInsidePortaledDropdown, false);
document.addEventListener('touchstart', stopIfInsidePortaledDropdown, false);
